(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["search-template"]) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function () {
		if (window.location.pathname.includes('/search')) {
			document.body.addEventListener('click', function (event) {
			const allDrawers = document.querySelectorAll('.accordion__item.js-accordion-filter-item-drawer');
			const clickedToggle = event.target.closest('.js-accordion-control'); 
			if (!event.target.closest('.js-accordion-filter-item-drawer') && !clickedToggle) {
				const anyActiveDrawer = document.querySelector('.accordion__item.js-accordion-filter-item-drawer.is-active');
				if (anyActiveDrawer && window.themeCore && window.themeCore.Accordion) {
					window.themeCore.Accordion.collapseAllItems('.js-filters-container-drawer');
				}
			} 
			if (clickedToggle) {
				const parentItem = clickedToggle.closest('.accordion__item.js-accordion-filter-item-drawer');
				if (window.themeCore && window.themeCore.Accordion) { 
				window.themeCore.Accordion.collapseAllItems('.js-filters-container-drawer', parentItem);
				}
			} 
			setTimeout(() => {
				allDrawers.forEach(drawer => {
				if (drawer.classList.contains('is-active')) {
					drawer.classList.add('left');
				} else {
					drawer.classList.remove('left');
				}
				});
			}, 550);
			});
		}
	}); 

  } catch(e) { console.error(e); }
})();
})();
